'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import I18n from 'I18n';
import { FORM_FIELD_TYPES } from 'MeetingsBase/constants/enums';
import UIList from 'UIComponents/list/UIList';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UINumberInput from 'UIComponents/input/UINumberInput';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UITextInput from 'UIComponents/input/UITextInput';
import UITextArea from 'UIComponents/input/UITextArea';
import UISelectInput from 'UIComponents/input/UISelectInput';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import UIDateInput from 'UIComponents/dates/UIDateInput';
import { fromMoment, toMomentUTC } from 'UIComponents/core/SimpleDate';
import ComponentWithPartials from 'UIComponents/mixins/ComponentWithPartials';
var EMAIL_FIELD = 'email';
var MINUS_SIGN = "\u2212";
var INVALID_NUM_CHARS_REGEX = new RegExp("[^0-9.," + MINUS_SIGN + "-]", 'g');
var BookingFormField = createReactClass({
  displayName: "BookingFormField",
  mixins: [ComponentWithPartials],
  propTypes: {
    fieldValue: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object, PropTypes.number, PropTypes.bool]),
    fieldName: PropTypes.string.isRequired,
    validation: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    setFormValue: PropTypes.func.isRequired,
    autocomplete: PropTypes.string,
    fieldType: PropTypes.string,
    type: PropTypes.string,
    isRequired: PropTypes.bool,
    fieldLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    fieldOptions: PropTypes.array,
    fieldIsCustom: PropTypes.bool,
    placeholder: PropTypes.string,
    numberDisplayHint: PropTypes.string,
    disabled: PropTypes.bool
  },
  getDefaultProps: function getDefaultProps() {
    return {
      autocomplete: 'off'
    };
  },
  getInitialState: function getInitialState() {
    return {
      hasBeenBlurred: false
    };
  },
  componentDidMount: function componentDidMount() {
    var _this$props = this.props,
        fieldType = _this$props.fieldType,
        fieldName = _this$props.fieldName,
        fieldValue = _this$props.fieldValue,
        setFormValue = _this$props.setFormValue;

    if (fieldType === FORM_FIELD_TYPES.CHECKBOX) {
      if (fieldValue == null) {
        setFormValue(fieldName, []);
      } else if (typeof fieldValue === 'string') {
        setFormValue(fieldName, fieldValue.split(';'));
      }
    }
  },
  isNameField: function isNameField() {
    return ['firstName', 'lastName'].includes(this.props.fieldName);
  },
  getEnumOptions: function getEnumOptions(options) {
    return options.map(function (option) {
      return {
        text: option.label,
        value: option.value
      };
    });
  },
  onFieldBlur: function onFieldBlur() {
    this.setState({
      hasBeenBlurred: true
    });
  },
  handleUnformattedNumberBlur: function handleUnformattedNumberBlur(fieldName, e) {
    // Ignore extraneous characters to mimic original UINumberInput behavior
    var validValue = e.target.value.replace(INVALID_NUM_CHARS_REGEX, '');
    this.props.setFormValue(fieldName, validValue);
    this.onFieldBlur();
  },
  handleEnumValueChange: function handleEnumValueChange(_ref) {
    var fieldName = _ref.fieldName,
        value = _ref.value;
    this.props.setFormValue(fieldName, value);
  },
  handleBooleanCheckboxValueChange: function handleBooleanCheckboxValueChange(e) {
    this.props.setFormValue(this.props.fieldName, e.target.checked);
  },
  handleValueChange: function handleValueChange(fieldName, e) {
    var value = e.target.value;

    if (fieldName === EMAIL_FIELD) {
      value = value.trim();
    }

    this.props.setFormValue(fieldName, value);
  },
  handleDateValueChange: function handleDateValueChange(fieldName, e) {
    this.props.setFormValue(fieldName, toMomentUTC(e.target.value).valueOf());
  },
  renderStandardField: function renderStandardField(FormFieldComponent) {
    var _this$props2 = this.props,
        fieldName = _this$props2.fieldName,
        fieldValue = _this$props2.fieldValue,
        autocomplete = _this$props2.autocomplete,
        placeholder = _this$props2.placeholder,
        disabled = _this$props2.disabled;
    return /*#__PURE__*/_jsx(FormFieldComponent, {
      style: {
        maxWidth: '100%'
      },
      autoComplete: autocomplete,
      type: "text",
      name: fieldName,
      className: "confirm-" + fieldName + "-field",
      value: fieldValue || '',
      onChange: this.partial(this.handleValueChange, fieldName),
      onBlur: this.onFieldBlur,
      placeholder: placeholder,
      disabled: disabled
    });
  },
  renderTextField: function renderTextField() {
    return this.renderStandardField(UITextInput);
  },
  renderTextAreaField: function renderTextAreaField() {
    return this.renderStandardField(UITextArea);
  },
  renderEnumType: function renderEnumType(renderFunction) {
    var fieldOptions = this.props.fieldOptions;
    return /*#__PURE__*/_jsx(UIList, {
      children: fieldOptions.map(function (option) {
        if (option.value !== '') {
          return renderFunction(option);
        }

        return null;
      })
    });
  },
  renderCheckbox: function renderCheckbox() {
    var _this$props3 = this.props,
        fieldValue = _this$props3.fieldValue,
        fieldLabel = _this$props3.fieldLabel,
        isRequired = _this$props3.isRequired,
        fieldName = _this$props3.fieldName,
        disabled = _this$props3.disabled;
    return /*#__PURE__*/_jsxs(UICheckbox, {
      className: "m-top-6",
      checked: fieldValue,
      onChange: this.handleBooleanCheckboxValueChange,
      onBlur: this.partial(this.onFieldBlur, {
        target: {
          name: fieldName
        }
      }),
      disabled: disabled,
      children: [fieldLabel, isRequired && /*#__PURE__*/_jsx("span", {
        children: " * "
      })]
    });
  },
  renderRadioInput: function renderRadioInput(option) {
    var _this$props4 = this.props,
        fieldName = _this$props4.fieldName,
        fieldValue = _this$props4.fieldValue,
        disabled = _this$props4.disabled;
    return /*#__PURE__*/_jsx(UIRadioInput, {
      name: fieldName + "-" + option.value,
      checked: option.value === fieldValue,
      disabled: disabled,
      onChange: this.partial(this.handleEnumValueChange, {
        fieldName: fieldName,
        value: option.value
      }),
      onBlur: this.partial(this.onFieldBlur, {
        target: {
          name: fieldName
        }
      }),
      children: option.label
    }, fieldName + "-" + option.value);
  },
  renderSelectField: function renderSelectField() {
    var _this$props5 = this.props,
        fieldName = _this$props5.fieldName,
        fieldType = _this$props5.fieldType,
        fieldOptions = _this$props5.fieldOptions,
        fieldValue = _this$props5.fieldValue,
        setFormValue = _this$props5.setFormValue,
        placeholder = _this$props5.placeholder;
    var placeholderText = I18n.text('select') || placeholder;

    if (fieldType === FORM_FIELD_TYPES.CHECKBOX) {
      return /*#__PURE__*/_jsx(UIToggleGroup, {
        name: fieldName,
        children: fieldOptions.map(function (option) {
          var onChange = function onChange(_ref2) {
            var checked = _ref2.target.checked;

            if (checked) {
              setFormValue(fieldName, [].concat(_toConsumableArray(fieldValue), [option.value]));
            } else {
              setFormValue(fieldName, fieldValue.filter(function (value) {
                return value !== option.value;
              }));
            }
          };

          return {
            onChange: onChange,
            checked: fieldValue.includes(option.value),
            key: option.value,
            label: option.label
          };
        }).map(function (option) {
          var key = option.key,
              label = option.label,
              props = _objectWithoutProperties(option, ["key", "label"]);

          return /*#__PURE__*/_jsx(UICheckbox, Object.assign({}, props, {
            children: label
          }), key);
        })
      });
    } else {
      // Do not switch to UISelect despite deprecation warning in UILibrary
      // See https://git.hubteam.com/HubSpot/MeetingsUI/pull/1446
      return /*#__PURE__*/_jsx(UISelectInput, {
        name: fieldName,
        onChange: this.partial(this.handleValueChange, fieldName),
        onBlur: this.onFieldBlur,
        options: this.getEnumOptions(fieldOptions),
        placeholder: placeholderText,
        value: fieldValue || undefined
      });
    }
  },
  renderEnumerationFields: function renderEnumerationFields() {
    var fieldType = this.props.fieldType;

    switch (fieldType) {
      case FORM_FIELD_TYPES.BOOLEAN_CHECKBOX:
        return this.renderCheckbox();

      case FORM_FIELD_TYPES.RADIO:
        return this.renderEnumType(this.renderRadioInput);

      default:
        return this.renderSelectField();
    }
  },
  renderUnformattedNumberField: function renderUnformattedNumberField() {
    var _this$props6 = this.props,
        fieldName = _this$props6.fieldName,
        fieldValue = _this$props6.fieldValue;
    return /*#__PURE__*/_jsx(UITextInput, {
      name: fieldName,
      onChange: this.partial(this.handleValueChange, fieldName),
      onBlur: this.partial(this.handleUnformattedNumberBlur, fieldName),
      value: fieldValue
    });
  },
  renderNumberField: function renderNumberField() {
    var _this$props7 = this.props,
        fieldName = _this$props7.fieldName,
        fieldValue = _this$props7.fieldValue,
        numberDisplayHint = _this$props7.numberDisplayHint;

    if (numberDisplayHint === 'unformatted') {
      return this.renderUnformattedNumberField();
    } else {
      return /*#__PURE__*/_jsx(UINumberInput, {
        name: fieldName,
        onChange: this.partial(this.handleValueChange, fieldName),
        onBlur: this.onFieldBlur,
        value: fieldValue
      });
    }
  },
  renderDateField: function renderDateField() {
    var _this$props8 = this.props,
        fieldName = _this$props8.fieldName,
        fieldValue = _this$props8.fieldValue;
    var dateValue;

    if (fieldValue) {
      var utcFieldValue = I18n.moment.utc(fieldValue);
      dateValue = isNaN(utcFieldValue) ? null : fromMoment(utcFieldValue);
    }

    return /*#__PURE__*/_jsx("div", {
      className: "meetings-date-input",
      children: /*#__PURE__*/_jsx(UIDateInput, {
        placeholder: I18n.moment.localeData().longDateFormat('L') || 'MM/DD/YYYY',
        value: dateValue,
        onChange: this.partial(this.handleDateValueChange, fieldName),
        onBlur: this.onFieldBlur
      })
    });
  },
  renderInput: function renderInput() {
    var _this$props9 = this.props,
        fieldIsCustom = _this$props9.fieldIsCustom,
        type = _this$props9.type,
        fieldType = _this$props9.fieldType;

    switch (true) {
      case type === FORM_FIELD_TYPES.ENUMERATION:
        return this.renderEnumerationFields();

      case type === FORM_FIELD_TYPES.NUMBER:
        return this.renderNumberField();

      case type === FORM_FIELD_TYPES.DATE:
        return this.renderDateField();

      case fieldIsCustom || fieldType === FORM_FIELD_TYPES.TEXTAREA:
        return this.renderTextAreaField();

      default:
        return this.renderTextField();
    }
  },
  render: function render() {
    var _this$props10 = this.props,
        validation = _this$props10.validation,
        isRequired = _this$props10.isRequired,
        fieldLabel = _this$props10.fieldLabel,
        fieldType = _this$props10.fieldType;
    var hasError = Boolean(validation) && this.state.hasBeenBlurred;
    var validationMessage;

    if (hasError) {
      validationMessage = validation;
    }

    var classes = !this.isNameField() ? 'm-top-6' : "";
    var isBooleanCheckbox = fieldType === FORM_FIELD_TYPES.BOOLEAN_CHECKBOX;
    return /*#__PURE__*/_jsx(UIFormControl, {
      className: classes,
      label: !isBooleanCheckbox && fieldLabel,
      required: isRequired,
      error: hasError,
      validationMessage: validationMessage,
      onBlur: this.onFieldBlur,
      children: this.renderInput()
    });
  }
});
export default BookingFormField;